import { render, staticRenderFns } from "./ElectionVoting.vue?vue&type=template&id=6992a491"
import script from "./ElectionVoting.vue?vue&type=script&lang=js"
export * from "./ElectionVoting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports